export default __webpack_public_path__ + "static/media/SAFETY SHEO ACCIDENT SIMULATOR.412528df.JPG";